import { Controller } from "@hotwired/stimulus"

// Smoke-Test der ST-Link-Bridge der Shell (window.configTool.stlink): listet die angeschlossenen Probes und zeigt die
// CLI-Version. Ausgabe per textContent: der Text der CLI ist Daten, nie Markup. Texte kommen als Values aus der View.
export default class extends Controller {
  static targets = ["output"]
  static values = { detecting: String, probe: String, noProbe: String }

  async detect() {
    this.#show(this.detectingValue)
    try {
      const [version, probes] = await Promise.all([this.#bridge.stlink.version(), this.#bridge.stlink.listProbes()])
      const lines = probes.length ? probes.map((sn, i) => `${this.probeValue} ${i}: ${sn}`) : [this.noProbeValue]
      this.#show([version, ...lines].join("\n"))
    } catch (error) {
      this.#show(error.message)
    }
  }

  #show(text) {
    this.outputTarget.textContent = text
  }

  get #bridge() {
    return window.configTool
  }
}
